import { LoadingButton } from "@mui/lab";
import { Box, CircularProgress, Dialog, DialogContent } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import useAxiosInstance from "../../../hooks/useAxiosInstance";
import { API_RESULT, API_VERSION } from "../../../enums/common.enum";
import { errorToast, handleError } from "../../../utils/common";
import CustomDialogTitle from "../../../components/Common/customDialogTitle";
import BorrowerGstValidate from "../SingleBorrower/Summary/components/BorrowerGstValidate";
import { updateGstSchemaBorrower } from "../../../schemas/providers.schema";

const EditGstModal = ({
  showEditGstModal,
  setShowEditGstModal,
  borrowerInfo,
  setBorrowerInfo,
}: any) => {
  const [loading, setLoading] = useState(false);
  const privateInstance = useAxiosInstance();

  const handleSubmit = async (values: any, actions: any) => {
    let payload: any = {
      borrower_id: borrowerInfo?.borrower_id,
      gst_no: values?.gst_no,
      name: values?.name,
      gst_name: values?.gst_name,
    };

    setLoading(true);

    try {
      const result = await privateInstance.post(
        `${API_VERSION.V3}/borrowers`,
        payload,
      );
      if (result?.data?.status === API_RESULT.SUCCESS) {
        setShowEditGstModal(false);
        const resultResponse = result.data.response;
        setBorrowerInfo({
          ...borrowerInfo,
          gst_no: resultResponse?.gst_no,
          name: resultResponse?.name,
        });
      } else {
        errorToast(result.data.message);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={showEditGstModal}
      onClose={() => setShowEditGstModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <CustomDialogTitle
        id="customized-dialog-title"
        onClose={() => setShowEditGstModal(false)}
      >
        Edit GST Details
      </CustomDialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            gst_no: borrowerInfo?.gst_no || "",
            name: "",
          }}
          validationSchema={updateGstSchemaBorrower}
          onSubmit={(values: any, actions: any) => {
            actions.setSubmitting(false);
            handleSubmit(values, actions);
          }}
        >
          {(props: any) => {
            const { values, touched, errors, handleBlur, setFieldValue } =
              props;
            return (
              <Form>
                <BorrowerGstValidate
                  gst_no={values.gst_no}
                  name={values.name}
                  handleBlur={handleBlur}
                  errors={errors}
                  touched={touched}
                  setFieldValue={setFieldValue}
                />
                <Box textAlign="center" mt={3}>
                  <LoadingButton
                    size="medium"
                    color="primary"
                    loading={loading}
                    loadingIndicator={
                      <CircularProgress size={20} sx={{ color: "#fff" }} />
                    }
                    variant="contained"
                    type="submit"
                  >
                    Update
                  </LoadingButton>
                </Box>
              </Form>
            );
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default EditGstModal;
